const formatCruiseSearchParams = (itinerary, travelOption) =>
  itinerary && travelOption
    ? {
        shipId: travelOption.ship.shipId,
        cruiseLineId: travelOption.cruiseLine.cruiseLineId,
        isCruiseTour: itinerary.itineraryCruiseTour,
      }
    : {};

export default formatCruiseSearchParams;
